import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { nextUrl, routes } from "util/routes";

// auth-constants.ts
export const AUTH_CONSTANTS = {
  SETTINGS: {
    AUTHORITY: "",
    CLIENT_ID: "dev-auth",
    RESPONSE_TYPE: "token",
  },
};

export class DevAuthManager extends UserManager {
  constructor() {
    const settings = {
      authority: AUTH_CONSTANTS.SETTINGS.AUTHORITY,
      client_id: AUTH_CONSTANTS.SETTINGS.CLIENT_ID,
      redirect_uri: `${window.location.origin}${routes.homePage()}`,
      post_logout_redirect_uri: `${window.location.origin}${routes.homePage()}`,
      monitorSession: true,
      loadUserInfo: true,
      response_type: AUTH_CONSTANTS.SETTINGS.RESPONSE_TYPE,
      userStore:
        typeof window !== "undefined"
          ? new WebStorageStateStore({ store: window.localStorage })
          : undefined,
    };
    super(settings);
  }

  // Override signinRedirect to handle custom auth flow
  async signinRedirect(args) {
    try {
      // First check if we already have a valid user
      const currentUser = await this.getUser();

      if (!currentUser || currentUser.expired) {
        if (currentUser?.expired) {
          await this.removeUser();
          await this.clearStaleState();
        }
        window.location.href = nextUrl(routes.devLogin());
        return Promise.resolve();
      }
    } catch (error) {
      console.error("Error in signinRedirect:", error);
      throw error;
    }
  }

  // Custom signout method
  async signoutRedirect(args) {
    try {
      // Clear user data from storage
      await this.removeUser();
      await this.clearStaleState();
      // Redirect to login page
      window.location.href = nextUrl(routes.devLogin());
    } catch (error) {
      console.error("Signout error:", error);
      throw error;
    }
  }
}
